import React from 'react'
import GridCell from './GridCell'
import { TiPin } from 'react-icons/ti'
import { FaCloudShowersHeavy } from 'react-icons/fa'
import { FaArrowLeftLong } from 'react-icons/fa6'

type GridCellPositionProps = {
	content: string | React.ReactNode | null
	richContent?: string | React.ReactNode
	i?: I
	isAvailable?: boolean
	isSubAvailable?: boolean
	isLocked?: boolean
	isNullPosition?: boolean
	isSubSplitting?: boolean
	subStatus: SubStatus
	onClick?: (i: I) => void
	positionName?: string
	className?: string
	onPointerDown?: (i: I, event: React.PointerEvent<HTMLDivElement>) => void
	endRosterIndex?: number
}

const GridCellPosition = (props: React.PropsWithChildren<GridCellPositionProps>) => {

	const icons = [ ]

	if (props.isSubSplitting) {
		icons.push(
			<span className="cell-subsplitting">
				<FaArrowLeftLong className="cell-subsplitting-1" />
				<FaArrowLeftLong className="cell-subsplitting-2" />
			</span>
		)
	} else if (props.isNullPosition) {
        icons.push(<FaCloudShowersHeavy className="icon-raincloud" />)
    } else if (props.isLocked) {
		icons.push(<TiPin className="icon-pinned" />)
	}

	return (
		<GridCell
			type="position"
			content={props.content}
			richContent={props.richContent}
			icons={icons}
			isAvailable={props.isAvailable}
			isSubAvailable={props.isSubAvailable}
			isNullPosition={props.isNullPosition}
			subStatus={props.subStatus}
			i={props.i}
			positionName={props.positionName}
			className={props.className}
			onClick={props.onClick}
			onPointerDown={props.onPointerDown}
			endRosterIndex={props.endRosterIndex}
		>
			{props.children}
		</GridCell>
	)
}

export default GridCellPosition
